<template>
    <AlertManagment/>
</template>
<script>

import AlertManagment from './AlertManagment.vue';
export default {
    name: 'EventManagementPage',
    components: { AlertManagment }
};
</script>
